import React from 'react';
import { FaVideo, FaFileAlt, FaMapMarkerAlt, FaYoutube, FaFilePdf, FaLinkedin } from 'react-icons/fa';
import { talksData } from '../data/talksData';
import './Talks.css';

const Talks = () => {
  return (
    <section id="talks" className="talks">
      <div className="container">
        <h2 className="section-title">Speaking & Presentations</h2>
        <p className="section-subtitle">
          Conference talks, workshops, and video content on AI and developer tools
        </p>

        <div className="talks-grid">
          {talksData.map((talk, index) => (
            <div key={index} className="talk-card card">
              <div className="talk-type-badge">
                {talk.type === 'video' ? <FaVideo /> : <FaFileAlt />}
                {talk.type}
              </div>

              <h3 className="talk-title">{talk.title}</h3>
              
              <div className="talk-meta">
                <span className="talk-event">
                  <FaMapMarkerAlt /> {talk.event}
                </span>
                <span className="talk-date">{talk.date}</span>
              </div>

              <p className="talk-description">{talk.description}</p>

              {talk.images && talk.images.length > 0 && (
                <div className="talk-photos">
                  {talk.images.map((imgSrc, i) => (
                    <a key={i} href={imgSrc} target="_blank" rel="noopener noreferrer" className="talk-photo-link">
                      <img src={imgSrc} alt={`${talk.title} ${i + 1}`} className="talk-photo" />
                    </a>
                  ))}
                </div>
              )}

              {talk.topics && (
                <div className="talk-topics">
                  <strong>Topics covered:</strong>
                  <ul>
                    {talk.topics.map((topic, i) => (
                      <li key={i}>{topic}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="talk-links">
                {talk.video && (
                  <a 
                    href={talk.video} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="talk-link video-link"
                  >
                    <FaYoutube /> Watch Video
                  </a>
                )}
                {talk.slides && (
                  <a 
                    href={talk.slides} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="talk-link slides-link"
                  >
                    <FaFilePdf /> View Slides
                  </a>
                )}
                {talk.linkedinPosts && talk.linkedinPosts.length > 0 && (
                  talk.linkedinPosts.map((postUrl, i) => (
                    <a
                      key={i}
                      href={postUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="talk-link"
                      aria-label={`LinkedIn post ${i + 1}`}
                    >
                      <FaLinkedin /> LinkedIn Post {i + 1}
                    </a>
                  ))
                )}
                {talk.article && (
                  <a 
                    href={talk.article} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="talk-link"
                  >
                    <FaFileAlt /> Related Article
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="talks-cta">
          <h3>Interested in having me speak at your event?</h3>
          <p>I'm available for conferences, workshops, and meetups on topics including GenAI, RAG, vector databases, and enterprise architecture.</p>
          <button 
            className="btn btn-primary"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Get in Touch
          </button>
        </div>
      </div>
    </section>
  );
};

export default Talks;

